import React, { useState, useEffect } from "react";
import "./Preload.css";
import Logo from "../../assets/logo/logo.svg";

const Preload = () => {
  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimationComplete(true);
    }, 2000); // Total animation duration

    return () => clearTimeout(timer);
  }, []);

  if (animationComplete) {
    return null;
  }

  return (
    <div className={`preload-container ${animationComplete ? 'fade-out' : ''}`}>
      <img src={Logo} alt="Logo" className="preload-logo" />
    </div>
  );
};

export default Preload;